import { render } from "./RejectPaymentRevesals.vue?vue&type=template&id=39b08bbb&scoped=true"
import script from "./RejectPaymentRevesals.vue?vue&type=script&lang=js"
export * from "./RejectPaymentRevesals.vue?vue&type=script&lang=js"

import "./RejectPaymentRevesals.vue?vue&type=style&index=0&id=39b08bbb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b08bbb"]])

export default __exports__